import React, { useState } from 'react';
import PropTypes from 'prop-types';

import InputBooleanBase, {
  INPUT_BOOLEAN_VARIANTS
} from '../internals/InputBooleanBase';
import InputBoolean from '../internals/InputBoolean';
import InputBooleanGroup, {
  variantPropTypeValidation
} from '../internals/InputBooleanGroup';

const RadioGroup = ({
  value,
  inline,
  variant,
  items,
  onBlur,
  onChange,
  ...otherProps
}) => {
  const [radioSelected, setRadioSelectedSelected] = useState(value);

  const handleChange = radioValue => event => {
    setRadioSelectedSelected(radioValue);

    if (onChange) onChange(radioValue, event);
  };

  const handleOnBlur = event => {
    if (onBlur) onBlur(radioSelected, event);
  };

  return (
    <InputBooleanGroup
      {...otherProps}
      type='radio'
      onBlur={handleOnBlur}
      variant={inline ? variant : INPUT_BOOLEAN_VARIANTS.regular}
      items={items}
      renderItems={({ itemValue, itemId, ...itemProps }) => (
        <InputBooleanBase
          {...itemProps}
          key={itemId}
          id={itemId}
          value={itemValue}
          onChange={handleChange(itemValue)}
          checked={radioSelected === itemValue}
        />
      )}
    />
  );
};

RadioGroup.defaultProps = {
  inline: true,
  variant: 'fixed'
};

RadioGroup.propTypes = {
  /* Name must be required to put all radios in the same group */
  name: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      ...InputBoolean.propTypes,
      label: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number
  ]),
  variant: variantPropTypeValidation
};

export default RadioGroup;
